import { render } from "./product-info.component.vue?vue&type=template&id=a84e25d8&scoped=true&ts=true"
import script from "./product-info.component.vue?vue&type=script&lang=ts"
export * from "./product-info.component.vue?vue&type=script&lang=ts"

import "./product-info.component.vue?vue&type=style&index=0&id=a84e25d8&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a84e25d8"]])

export default __exports__